import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { useIsMobile } from "../../components/Mui3WidthProvider"

export function AuthLayout(props: React.PropsWithChildren<{}>){

    const mobile = useIsMobile();

    return (
    <Grid style={{height: "100vh" }} container direction="column" justifyContent="center" alignItems="center">
        <Grid item style={{ height: mobile ? "100%" : undefined}}>
            <Paper 
                elevation={3}
                style={{
                    padding: mobile ? '0px 30px' : '0px 50px',
                    margin: mobile ? 0 : undefined,
                    height: "100%",
                    paddingTop: mobile ? "5%" : undefined,
                    maxWidth: 500,
                }}
            >
                <Grid container justifyContent="center" alignItems="center">
                    <img 
                        style={{ margin:"30px 0px 20px 0px", maxWidth: 180}}
                        src="//i.cdn-sc.com/Logos/sm-stacked300.png"
                        alt="Sermon Maker Logo"
                    />
                </Grid>
                {props.children}
            </Paper>
        </Grid>
    </Grid>
    )
}